import React, {useState, useEffect} from 'react';
import axios from 'axios';
import '../../style/Forms.css';

const CriticalNotification = () => {
    const [title, setTitle] = useState('');
    const [body, setBody] = useState('');
    const [code, setCode] = useState(''); // New state for code
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const [history, setHistory] = useState([]);
    const [showPatterns, setShowPatterns] = useState(false);
    const [showHistory, setShowHistory] = useState(false);
    const [searchCode, setSearchCode] = useState('');

    const patterns = [
        {title: 'Оповещение о землетрясении', code: '20101', body: 'Землетрясение на территории, сила ХХ баллов'},
        {
            title: 'Повторное землетрясение',
            code: '20102',
            body: 'Землетрясение в приграничных государствах, сила ХХ баллов'
        },
        {title: 'Оползень', code: '20202', body: 'Угроза схода оползней в районе'},
        {title: 'Обвал', code: '20203', body: 'Угроза возникновения обвалов на участке'},
        {title: 'Сель', code: '20205', body: 'Угроза схода селя по руслу реки'},
        {title: 'Селевой поток вследствие дождя', code: '20206', body: 'Угроза селевого потока вследствие дождя'},
        {title: 'Лавина', code: '20210', body: 'Угроза схода лавин'},
        {title: 'Шквалы', code: '20304', body: 'Угроза усиления ветра с порывами до ХХ м/с'},
        {title: 'Крупный град', code: '20307', body: 'Штормовое предупреждение дождя с переходом в крупный град'},
        {title: 'Ливневые дожди', code: '20309', body: 'Штормовое предупреждение. Сильный дождь в районе'},
        {
            title: 'Сильный снегопад',
            code: '20311',
            body: 'Штормовое предупреждение. Ожидается сильный снегопад, метель'
        },
        {title: 'Сильная жара', code: '20317', body: 'Штормовое предупреждение. Повышение температуры до ХХ °С'},
        {title: 'Сильный туман', code: '20318', body: 'Штормовое предупреждение. Сильный туман на дорогах'},
        {title: 'Заморозки', code: '20320', body: 'Штормовое предупреждение. Заморозки до ХХ °С'},
        {
            title: 'Сильное колебание уровня моря',
            code: '20404',
            body: 'Штормовое предупреждение. Нагонные волны на участке'
        },
        {title: 'Наводнение', code: '20501', body: 'Угроза наводнения в регионе'},
        {title: 'Половодье', code: '20502', body: 'Штормовое предупреждение. Угроза половодья вдоль рек'},
        {title: 'Паводок', code: '20503', body: 'Штормовое предупреждение. Угроза паводков на реке'},
        {title: 'Лесной пожар', code: '20701', body: 'Угроза возникновения лесного пожара'},
        {title: 'Степной пожар', code: '20702', body: 'Угроза возникновения степного пожара'},
        {title: 'Эпидемия', code: '20803', body: 'Объявлен карантин в населенных пунктах, ограничен проезд'},
        {
            title: 'Повышенный уровень радиации',
            code: '21508',
            body: 'Угроза радиационного заражения в населенных пунктах'
        },
        {
            title: 'Загрязнение водоемов',
            code: '21603',
            body: 'Произошло загрязнение водоема, купание и использование воды запрещено'
        },
        {
            title: 'Авария с выбросом ядовитых веществ',
            code: '10301',
            body: 'Внимание! Угроза выброса ядовитых веществ, следуйте указаниям по ТВ'
        },
        {
            title: 'Превышение ПДК вредных веществ',
            code: '10403',
            body: 'Внимание! В воздухе обнаружены вредные вещества выше нормы'
        },
        {title: 'Авария в метрополитене', code: '10705', body: 'Произошла авария в метрополитене, станции закрыты'},
        {
            title: 'Авария на ГЭС',
            code: '10801',
            body: 'Угроза затопления населенных пунктов и отключения электроэнергии'
        },
        {
            title: 'Авария на электростанции',
            code: '10803',
            body: 'Отключение электроэнергии в населенных пунктах из-за аварии на электростанции'
        },
        {title: 'Прорыв плотины', code: '11201', body: 'Угроза прорыва плотины с возможным затоплением'},
        {title: 'Аварийный сброс воды', code: '11203', body: 'Угроза аварийного сброса воды из водохранилища'},
        {title: 'Авария на скважинах', code: '11303', body: 'Авария с открытым нефтяным или газовым фонтаном'}
    ];

    const filteredPatterns = patterns.filter(pattern =>
        pattern.code.includes(searchCode)
    );

    useEffect(() => {
        // Get notification history
        axios.get('https://api.alertapp.kz/api/v1/critical/history')
            .then(response => setHistory(response.data.filter(notification => notification.type === 'critical')))
            .catch(error => console.error('Ошибка при получении истории:', error));
    }, []);

    const handlePatternSelect = (pattern) => {
        setTitle(pattern.title);
        setBody(pattern.body);
        setCode(pattern.code); // Set the code field when selecting a pattern
        setShowPatterns(false);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');

        if (!title || !code) {
            setError('Заполните все поля');
            setLoading(false);
            return;
        }

        try {
            // Send notification
            await axios.post('https://api.alertapp.kz/api/v1/critical/send', {title, body: body, code});
            await axios.post('https://ws.alertapp.kz/send-notification', {message: title, type: body || ""});
            alert('Критическое уведомление успешно отправлено');

            // Update history
            const newNotification = {title, body, code, date: new Date().toLocaleString(), type: 'critical'};
            setHistory([...history, newNotification]);
        } catch (err) {
            setError('Ошибка при отправке уведомления');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="form-container">
            <h2>Отправить критическое уведомление</h2>
            <form onSubmit={handleSubmit} className="notification-form">
                <input
                    type="text"
                    placeholder="Введите название"
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                    className="input-field"
                />
                <input
                    type="text"
                    placeholder="Введите код"
                    value={code}
                    onChange={(e) => setCode(e.target.value)}
                    className="input-field"
                />
                <textarea
                    placeholder="Введите сообщение"
                    value={body}
                    onChange={(e) => setBody(e.target.value)}
                    className="textarea-field"
                />
                {error && <p className="error-text">{error}</p>}
                <button type="submit" className="submit-btn" disabled={loading}>
                    {loading ? 'Отправка...' : 'Отправить'}
                </button>
            </form>

            <div className="panel-buttons">
                <button onClick={() => setShowPatterns(!showPatterns)} className="panel-btn">
                    {showPatterns ? 'Скрыть шаблоны' : 'Показать шаблоны'}
                </button>
                <button onClick={() => setShowHistory(!showHistory)} className="panel-btn">
                    {showHistory ? 'Скрыть историю' : 'Показать историю'}
                </button>
            </div>

            {showPatterns && (
                <div className="patterns-panel">
                    <h3>Готовые шаблоны уведомлений</h3>
                    <input
                        type="text"
                        placeholder="Поиск по коду шаблона"
                        value={searchCode}
                        onChange={(e) => setSearchCode(e.target.value)}
                        className="input-field"
                    />
                    <ul className="pattern-list">
                        {filteredPatterns.map((pattern, index) => (
                            <li key={index} className="pattern-item">
                                <strong>{pattern.title}</strong><br/>
                                <span>Код: {pattern.code}</span><br/>
                                <button onClick={() => handlePatternSelect(pattern)} className="panel-btn">
                                    Выбрать
                                </button>
                            </li>
                        ))}
                    </ul>
                </div>
            )}

            {showHistory && (
                <div className="history-panel">
                    <h3>История отправленных уведомлений</h3>
                    <ul>
                        {history.length === 0 ? (
                            <li>Нет отправленных уведомлений</li>
                        ) : (
                            history.map((item, index) => (
                                <li key={index} className="history-item">
                                    <strong>Название:</strong> {item.title} <br/>
                                    <strong>Код:</strong> {item.code} <br/>
                                    <strong>Сообщение:</strong> {item.body} <br/>
                                    <strong>Дата отправки:</strong> {new Date(item.dateSent).toLocaleString()} <br/>
                                </li>
                            ))
                        )}
                    </ul>
                </div>
            )}

        </div>
    );
};

export default CriticalNotification;
